export enum ActionType {
  light,
  dark,
}

export enum LayoutActionType {
  hideStaff,
  hideVisualizer,
  showAll,
}
